import { useAxios } from "@hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useTranslation } from "react-i18next";
import { convertDayjsToTotalSeconds } from "../../configurations/helpers";

export const useAddExam = () => {
    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const addExam = async (exam: any) => {
 

        exam = {
            ...exam,
            categories: exam.categories.map((category: any) => ({id: category})),
            timeInSeconds: convertDayjsToTotalSeconds(exam.timeInSeconds),
        }
        try {
            const response = await axios.post("/api/exam", exam);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    return useMutation({mutationFn: addExam, onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ["exams"]});
        message.success(t("messages.success.addExam"));
    }});
}